
import React from 'react';
import { format } from 'date-fns';
import { pl, enUS } from 'date-fns/locale';
import { useLanguage } from '@/hooks/useLanguage';
import { RansomwareItem } from '@/types/dashboard';
import { Badge } from '@/components/ui/badge';

interface RansomwareListItemProps {
  attack: RansomwareItem;
}

export function RansomwareListItem({ attack }: RansomwareListItemProps) {
  const { language } = useLanguage();

  const formatDate = (dateString: string) => {
    try {
      const date = new Date(dateString);
      return format(date, 'dd MMM yyyy', {
        locale: language === 'pl' ? pl : enUS,
      });
    } catch (error) {
      console.error("Date formatting error:", error, "for date:", dateString);
      return dateString;
    }
  };

  // Safely display data with fallbacks
  const victim = attack?.victim || 'Unknown victim';
  const group = attack?.group || 'Unknown group';
  const domain = attack?.domain || '';
  const attackDate = attack?.attackdate || '';

  return (
    <div className="group h-full flex flex-col flex-1 min-h-0">
      <div className="flex flex-col flex-1 justify-center p-2 rounded-lg min-h-0">
        <div className="flex justify-between items-start gap-2 mb-1 shrink-0">
          <span className="font-medium text-sm leading-tight flex-1 line-clamp-2">{victim}</span>
          <Badge variant="outline" className="ml-2 text-xs flex-shrink-0 h-5">
            {group}
          </Badge>
        </div>
        <div className="flex justify-between text-xs text-muted-foreground mt-auto pt-1 shrink-0">
          <span className="truncate max-w-[60%]">{domain}</span>
          <span className="ml-2 whitespace-nowrap flex-shrink-0">
            {attackDate ? formatDate(attackDate) : ''}
          </span>
        </div>
      </div>
    </div>
  );
}
